import { Link } from '@on3/ui-lib/components/Link';
import { useAuth } from '@on3/ui-lib/index';
import { classYearClaimCutoff } from '@on3/ui-lib/utils/constants';
import { useAthlete } from '@public/contexts/AthleteProvider';
import clsx from 'clsx';

import styles from './AthleteClaimButton.module.scss';

interface AthleteClaimButtonProps {
  buttonText?: string;
  className?: string;
}

export const AthleteClaimButton: React.FC<AthleteClaimButtonProps> = ({
  buttonText = 'Claim Profile',
  className,
}) => {
  const { athlete } = useAthlete();
  const { isVerifiedPlayer } = useAuth();
  const baseUrl = `/rivals/${athlete.slug}`;
  const link = baseUrl + '/claim-profile/';

  if (athlete?.classYear && athlete.classYear < classYearClaimCutoff) {
    return null;
  }

  return (
    <>
      {!isVerifiedPlayer(athlete?.key) && !athlete?.athleteVerified && (
        <Link
          className={clsx(styles.button, className)}
          forceReload
          href={link}
        >
          {buttonText}
        </Link>
      )}
    </>
  );
};
